export enum CanvasserCapability {
  Device = 'Device',
  Loan = 'Loan',
  Aplus = 'Aplus',
  AplusInsurance = 'AplusInsurance',
  Dashboard = 'Dashboard',
}
